import { GetRelativePointerPosition } from 'utils/Global';
const Konva = window.Konva;
export default class CreateLayerTools {
  constructor(drawingLayer, strokeNormalizer) {
    this.startPos = 0;
    this.newLayerRect = 0;
    this.endPos = 0;
    this.drawingLayer = drawingLayer;
    this.canvasRect = {};
    this.strokeNormalizer = strokeNormalizer;
  }

  onMouseDown(evt) {
    this.startPos = GetRelativePointerPosition(this.drawingLayer);
  }

  onMouseMove(evt, startWell, endWell) {
    this.endPos = GetRelativePointerPosition(this.drawingLayer);

    // Determine horizontal direction
    const leftWell = startWell.x <= endWell.x ? startWell : endWell;
    const rightWell = startWell.x > endWell.x ? startWell : endWell;

    // Determine vertical direction
    const topWell = startWell.y <= endWell.y ? startWell : endWell;
    const bottomWell = startWell.y > endWell.y ? startWell : endWell;

    const rectX = leftWell.x;
    const rectY = topWell.y;

    const rectWidth = rightWell.x + rightWell.w - leftWell.x;
    const rectHeight = bottomWell.y + bottomWell.h - topWell.y;

    if (this.newLayerRect == 0) {
      this.newLayerRect = new Konva.Rect({
        x: rectX,
        y: rectY,
        width: rectWidth,
        height: rectHeight,
        stroke: 'blue',
        strokeWidth: 1 / this.strokeNormalizer,
        fill: 'rgba(0,0,0,0.3)',
        draggable: false,
        listening: false,
      });
      this.drawingLayer?.add(this.newLayerRect);
      this.drawingLayer?.batchDraw();
    } else {
      this.newLayerRect.setAttrs({
        x: rectX,
        y: rectY,
        width: rectWidth,
        height: rectHeight,
      });
    }
    this.drawingLayer?.batchDraw();
  }

  onMouseUp(evt) {
    this.endPos = GetRelativePointerPosition(this.drawingLayer);

    return {
      x: Math.min(this.startPos.x, this.endPos.x),
      y: Math.min(this.startPos.y, this.endPos.y),
      width: Math.abs(this.endPos.x - this.startPos.x),
      height: Math.abs(this.endPos.y - this.startPos.y),
    };
  }
}
